import React from 'react';
import styled, { css } from 'styled-components';
import { Link, NavLink } from 'react-router-dom';
import { Text } from '@nicheinc/campus-ds';

const disabledStyles = () => css`
	pointer-events: none;
	background-color: ${({ theme }) => theme.colors.system.background.weak};
	color: ${({ theme }) => theme.colors.system.text.medium};
`;

const nonDisabledStyles = () => css<{
	$isAccordionHeader?: boolean;
	$isActivePage?: boolean;
	$variant?: 'system' | 'light';
}>`
	&:hover {
		background-color: ${({ $isAccordionHeader, $variant, theme }) =>
			!$isAccordionHeader && $variant === 'system'
				? theme.colors.system.background.xWeak
				: theme.colors.system.background.white};
		color: ${({ theme }) => theme.colors.primary.text.xStrong};
	}

	${({ $isActivePage, $variant }) =>
		typeof $isActivePage === 'boolean'
			? css`
					border-left: 3.5px solid
						${({ theme }) =>
							$isActivePage ? theme.rootColors.jade[400] : 'initial'};
					background-color: ${({ theme }) =>
						$isActivePage
							? $variant === 'system'
								? theme.colors.system.background.xWeak
								: theme.colors.system.background.white
							: 'initial'};
				`
			: css`
					&.active {
						border-left: 3.5px solid
							${({ theme }) => theme.rootColors.jade[400]};
						background-color: ${({ theme }) =>
							theme.colors.system.background.xWeak};
						color: ${({ theme }) => theme.colors.primary.text.xStrong};
					}
				`};
`;

const mainLinkStyles = (props: any) => css<{
	$isNavbarCollapsed?: boolean;
	$isDisabled?: boolean;
	$isAccordionHeader?: boolean;
	$isSubMenusThreaded?: boolean;
	$isActivePage?: boolean;
	$variant?: 'system' | 'light';
}>`
	display: flex;
	align-items: center;
	white-space: nowrap;
	padding-left: ${({ $isAccordionHeader, $isSubMenusThreaded, theme }) =>
		$isAccordionHeader && !$isSubMenusThreaded
			? theme.spacing.xs
			: theme.spacing.xs};
	padding-right: ${({ theme }) => theme.spacing.xs};
	height: 40px;
	width: ${({ $isNavbarCollapsed }) => ($isNavbarCollapsed ? '34px' : 'auto')};
	margin: ${({ $isNavbarCollapsed }) =>
		$isNavbarCollapsed ? '0px auto' : '0px'};
	gap: ${({ theme }) => theme.spacing.xs};
	cursor: pointer;
	text-decoration: none;
	color: ${({ theme }) => theme.colors.primary.text.xStrong};
	border-left: 3.5px solid transparent;
	position: relative;
	transition: ${({ theme }) => theme.transitions.ease01};
	${({ $isDisabled }) => ($isDisabled ? disabledStyles : nonDisabledStyles)};

	justify-content: ${({ $isNavbarCollapsed }) =>
		$isNavbarCollapsed && 'center'};

	&:hover {
		text-decoration: none;
	}
`;
export const NavLinkButtonContainer = styled(NavLink)<{
	$isNavbarCollapsed?: boolean;
	$isDisabled?: boolean;
	$isAccordionHeader?: boolean;
	$isSubMenusThreaded?: boolean;
	$isActivePage?: boolean;
	$variant?: 'system' | 'light';
}>`
	${mainLinkStyles}
`;

export const LinkButtonContainer = styled(Link)<{
	$isNavbarCollapsed?: boolean;
	$isDisabled?: boolean;
	$isAccordionHeader?: boolean;
	$isSubMenusThreaded?: boolean;
	$isActivePage?: boolean;
	$variant?: 'system' | 'light';
}>`
	${mainLinkStyles}
`;

export const NavLinkButtonWrapper = styled.div`
	margin-left: auto;
`;

export const NavLinkButtonIconWrapper = styled.button`
	display: contents;
`;

export const RedirectLinkIconWrapper = styled.div`
	display: flex;
	justify-content: end;
	flex: 1;
`;
export const BadgeWrapper = styled.span`
	margin-left: auto;
`;

export const StatusBulletWrapper = styled.span`
	margin-left: auto;
	position: absolute;
	right: 4px;
	top: 5px;
	display: inline-flex;
`;

//If the icon changes its size, we should modify the min-width
export const IconContainer = styled.div<{ isActivePage?: boolean | null }>`
	height: 34px;
	color: ${({ isActivePage, theme }) => 'inherit'};
	display: flex;
	justify-content: center;
	align-items: center;

	.active-icon {
		opacity: ${({ isActivePage }) => (isActivePage ? 1 : 0)};
		position: ${({ isActivePage }) => (isActivePage ? 'relative' : 'absolute')};
	}

	.inactive-icon {
		opacity: ${({ isActivePage }) => (isActivePage ? 0 : 1)};
		position: ${({ isActivePage }) => (isActivePage ? 'absolute' : 'relative')};
	}
`;

export const NavText = styled((props: any) => <Text {...props} />)`
	overflow: hidden;
	display: inline-block;
	padding-block: 4px;
	margin-block: -4px;
`;
